import React from "react"
import { type TransProps, useTranslation, Trans } from "react-i18next"

interface HintProps {
  type: "tip" | "errormessage"
  translation: string
  show?: boolean
  interpolations?: Record<string, string>
  components?: TransProps<any>["components"]
}

const Hint: React.FC<HintProps> = ({ type, translation, show, interpolations, components }) => {
  const { t } = useTranslation()
  const tOptions: Record<string, string> = { ...interpolations }

  if (typeof show !== "undefined" && !show) {
    return null
  }

  if (type === "errormessage") {
    return <div className="hint errormessage paragraph-2xs">{t(translation, tOptions)}</div>
  }

  if (components) {
    return (
      <div className="hint">
        {type === "tip" && <span className="paragraph-2xs bold">{t("toolbox.tip")}: </span>}
        <span className="paragraph-2xs">
          <Trans i18nKey={translation} values={interpolations} components={components} />
        </span>
      </div>
    )
  }

  return (
    <div className="hint">
      {type === "tip" && <span className="paragraph-2xs bold">{t("toolbox.tip")}: </span>}
      <span className="paragraph-2xs">{t(translation, tOptions)}</span>
    </div>
  )
}

export default Hint
